import { useState } from 'react';
import { RsInput, RsNumberInput, RsTextArea } from 'components/Rsuite/Input';
import { RsSelect, RsMultiSelect } from 'components/Rsuite/Select';
import { RsBasicRaio, RsPriceRadio } from './Radio';
import styles from './testTemplate.module.scss';

import FutureDateRangePicker from 'components/DateRangePicker/FutureDateRangePicker';

const InputTest = () => {
  const [value, setValue] = useState('');

  return <RsInput value={value} onChange={setValue} />;
};

const NumberInputTest = () => {
  const [price, setPrice] = useState<string>('');

  return (
    <RsNumberInput
      prefix='NTD'
      num={price}
      onChange={setPrice}
      scrollable
      showBtn
    />
  );
};

const TextAreaTest = () => {
  const [text, setText] = useState('');

  return <RsTextArea value={text} onChange={setText} />;
};

const SelectTest = () => {
  const [value, setValue] = useState<string | null>('');

  const data = [
    'Eugenia',
    'Bryan',
    'Linda',
    'Nancy',
    'Lloyd',
    'Alice',
    'Julia',
    'Albert',
  ].map((item) => ({ label: item, value: item }));

  return <RsSelect data={data} value={value} onChange={setValue} />;
};

const data = [
  { firstLetter: 'A', value: 'Alan', label: 'Alan' },
  { firstLetter: 'B', value: 'Benson', label: 'Benson' },
  { firstLetter: 'B', value: 'Bob', label: 'Bob' },
  { firstLetter: 'D', value: 'David', label: 'David' },
  { firstLetter: 'D', value: 'Danny', label: 'Danny' },
  { firstLetter: 'E', value: 'Eddie', label: 'Eddie' },
  { firstLetter: 'E', value: 'Elon', label: 'Elon' },
  { firstLetter: 'F', value: 'Friseur', label: 'Friseur' },
  { firstLetter: 'F', value: 'Frank', label: 'Frank' },
  { firstLetter: 'F', value: 'Freddy', label: 'Freddy' },
];

const MultiSelectTest = () => {
  const [value, setValue] = useState<string[]>([]);

  return (
    <RsMultiSelect
      groupBy='firstLetter'
      data={data}
      value={value}
      onChange={setValue}
    />
  );
};

const RadioTest = () => {
  const [selected, setSelected] = useState<string>('');

  const data = [
    'Eugenia',
    'Bryan',
    'Linda',
    'Nancy',
    'Lloyd',
    'Alice',
    'Julia',
    'Albert',
  ].map((item) => ({ label: item, value: item, hint: 'hint' }));

  return (
    <RsBasicRaio
      data={data}
      selected={selected}
      onChange={setSelected}
      inline
    />
  );
};

const RsPriceRadioTest = () => {
  const defaultValues = [
    'Eugenia',
    'Bryan',
    'Linda',
    'Nancy',
    'Lloyd',
    'Alice',
    'Julia',
    'Albert',
  ];

  const data = defaultValues.map((value) => ({
    label: value,
    value: value,
    hint: 'hint',
    errorMessage: 'error',
  }));
  const [selected, setSelected] = useState<string>('');
  const [prices, setPrices] = useState<Record<string, string>>(() =>
    Object.fromEntries(defaultValues.map((value) => [value, ''])),
  );
  const onValueChange = (v: string) => {
    setSelected(v);
  };

  return (
    <RsPriceRadio
      className={styles.RsPriceRadioTest}
      data={data}
      selected={selected}
      onChange={onValueChange}
      prices={prices}
      onPriceChange={setPrices}
    />
  );
};

const DeprecatedDateRange = () => {
  const [startDate, setStartDate] = useState('2025-02-12 18:00:00');
  const [endDate, setEndDate] = useState('2025-02-16 18:00:00');

  const handlChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };
  return (
    <FutureDateRangePicker
      startDate={startDate}
      endDate={endDate}
      minDate='2025-02-02 18:00:00'
      maxDate='2025-02-20 18:00:00'
      format='YYYY-MM-DD HH:mm:ss'
      onChange={handlChange}
      startDatePickerDisabled
      // showTimePicker={false}
    />
  );
};

export const TestTemplate = () => {
  return (
    <div className={styles.TestTemplate}>
      <h2>Input</h2>
      <InputTest />
      <h2>NumberInput</h2>
      <NumberInputTest />
      <h2>TextArea</h2>
      <TextAreaTest />
      <h2>Select</h2>
      <SelectTest />
      <h2>MultiSelect</h2>
      <MultiSelectTest />
      <h2>Radio</h2>
      <RadioTest />
      <h2>PriceRsRadio</h2>
      <RsPriceRadioTest />
      <h2>DeprecatedDateRange</h2>
      <DeprecatedDateRange />
      {/* <h2>FormTemplate</h2>
      <FormTemplate /> */}
    </div>
  );
};
